<template>
  <v-hover v-slot:default="{ hover }">
      <!-- :elevation="hover || isActiveOption ? 12 : 2" -->
    <v-card
      :max-width="$vuetify.breakpoint.smAndDown ? 200 : 344"
      :min-width="$vuetify.breakpoint.smAndDown ? 200 : 344"
      :style="`boxShadow: 0px ${isActiveOption || hover
        ? '6px 35px rgba(0, 0, 0, 0.2)'
        : '6px 30px rgba(0, 0, 0, 0.08)'} !important; border-radius: 7px`"
      :to="option.to"
      @click.stop="openApplicationList(false)"
      :color="isActiveOption ? 'primary' : ''"
      :class="[
        { 'on-hover': hover || isActiveOption },
        `${$vuetify.breakpoint.smAndDown ? 'py-5' : 'py-10'}`,
        'pointer',
        'px-6',
        'd-flex align-center flex-column justify-center',
      ]">
      <div class="justify-center align-center d-flex flex-wrap">
        <v-icon
          :size="$vuetify.breakpoint.smAndDown ? 100 : 150"
          :color="isActiveOption ? 'white' : 'primary'"
        >
          {{ option.icon }}
        </v-icon>
      </div>

      <v-card-title
        :class="[
          `${$vuetify.breakpoint.smAndDown ? 'body-2' : ''}`,
          'font-weight-bold',
          `${isActiveOption ? 'white--text' : 'primary--text'}`,
          'd-flex',
          'justify-center',
          'text-center',
          'word-break',
          'font-weight-bold',
          'pb-1'
        ]">
        {{ titleUpperCase }}
      </v-card-title>

      <v-card-text :class="[
          `${$vuetify.breakpoint.smAndDown ? 'caption' : ''}`,
          `${isActiveOption ? 'white--text' : 'black--text'}`,
          'text-center',
          'd-none',
          'd-sm-block',
          'font-weight-light',
        ]"
      >
        {{ option.description }}
      </v-card-text>
    </v-card>
  </v-hover>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'option-menu',
  props: ['option'],
  computed: {
    titleUpperCase() {
      return this.option.title.toUpperCase();
    },
    isActiveOption() {
      return this.$route.name.includes(this.option.to.name);
    },
  },
  methods: {
    ...mapMutations(['openApplicationList']),
  },
};
</script>

<style scoped>
  .on-hover {
    transition: ease .3s all;
    transform: translateY(-5px) scale(1.01);
  }
</style>
